import { SelectItem } from "components/Forms/FormSelect";
import { StateWasteStreamRegistrationStatus } from "generated-graphql/graphql";

import { StatusBadge } from "./StatusBadge";
import { statusLabel } from "./statusBadgeConstants";

// Shared select items for the status field on the registration detail drawer
// and create dialog. Each carries a StatusBadge node so the select renders the
// same pill as the grid; `display` keeps the plain label for search/display-only
// text. Lives apart from StatusBadge.tsx so that file exports only its
// component (react-refresh/only-export-components).
export const STATUS_SELECT_ITEMS: SelectItem[] = Object.values(
  StateWasteStreamRegistrationStatus
).map((value) => ({ value, display: statusLabel(value), node: <StatusBadge status={value} /> }));
